<div class="language-header__outer">
	@if (!disabled) {
		<div class="language-header" (click)="togglePopOver()">
			@if (currentUser && currentUser.loggedIn && currentUser.data.settings.showTranslations) {
				@if (isGerman) {
					Alle Sprachen
				} @else {
					All languages
				}
			} @else {
				{{ language.title }}
			}
			<span class="phb-icon icon icon--settings"></span>
		</div>
	}
</div>

